import { createFileRoute, notFound } from "@tanstack/react-router";
import { PDPA_QA, PDPA_QA_BY_SLUG, PDPA_REVIEWED_ISO, PDPA_REVIEWED_TH } from "@/data/pdpa/questions";
import { ClusterQaDetail, clusterQaDetailHead, type ClusterQaMeta } from "@/lib/qa/cluster-pages";

const M: ClusterQaMeta = { base: "/pdpa", label: "PDPA คุ้มครองข้อมูลส่วนบุคคล", reviewedIso: PDPA_REVIEWED_ISO, reviewedTh: PDPA_REVIEWED_TH };

export const Route = createFileRoute("/pdpa/q/$slug")({
  loader: ({ params }) => { if (!PDPA_QA_BY_SLUG[params.slug]) throw notFound(); return { slug: params.slug }; },
  head: ({ loaderData }) => clusterQaDetailHead(M, loaderData ? PDPA_QA_BY_SLUG[loaderData.slug] : undefined),
  component: Page,
});

function Page() {
  const { slug } = Route.useLoaderData();
  const qa = PDPA_QA_BY_SLUG[slug];
  if (!qa) throw notFound();
  return <ClusterQaDetail m={M} qa={qa} all={PDPA_QA} />;
}
